
  <ng-container previewContent>
    <div class="preview-panel pb-0 pt-5">
      <div class="form-group d-flex mb-3">
        <label class="form-check mr-3">
          <input
            type="radio"
            class="form-check-input"
            name="groupType"
            [value]="'single'"
            [checked]="selectedGroupType === 'single'"
            (change)="onGroupTypeChange('single')"
          />
          {{ 'NEW_ROSTER' | translate }}
        </label>
    
        <label class="form-check">
          <input
            type="radio"
            class="form-check-input"
            name="groupType"
            [value]="'multi'"
            [checked]="selectedGroupType === 'multi'"
            (change)="onGroupTypeChange('multi')"
          />
          {{ 'NEW_ROSTER_OF_GROUPS' | translate }}
        </label>
      </div>
    </div>
    
    <app-roster-add *ngIf="selectedGroupType === 'single'"></app-roster-add>
    <app-roster-group-add *ngIf="selectedGroupType === 'multi'"></app-roster-group-add>
  </ng-container>
  